import { z } from 'zod';

/** A service id: a catalog service (`slack`), or `<plugin>/<service>` for a plugin's own service. */
export const serviceIdSchema = z
  .string()
  .max(160)
  .regex(/^(?:[a-z0-9][a-z0-9._-]*\/)?[a-z0-9_][a-z0-9_-]*$/);

export const pluginConnectionRequirementSchema = z
  .object({
    service: serviceIdSchema,
    /** An optional connection unlocks more of the plugin; a required one is needed to use it. */
    optional: z.boolean().default(false),
    /** OAuth scopes the plugin needs on top of those the type declares. */
    scopes: z
      .array(
        z
          .string()
          .min(1)
          .max(256)
          .regex(/^[^\s,]+$/),
      )
      .max(64)
      .optional(),
  })
  .strict();
export type PluginConnectionRequirement = z.infer<typeof pluginConnectionRequirementSchema>;

export const pluginRequiresSchema = z
  .object({
    /** The accounts the plugin uses, by service; connections stay on the hub (`adr-connections-hub.md`). */
    connections: z.array(pluginConnectionRequirementSchema).max(64).optional(),
  })
  .strict();
